import apiService from './api-service'

const banksService = {}

banksService.list = function (params) {
  return apiService.get(`/banks`, { params }).then(res => res.data)
}

/**
 * Get a investors bank_data by it's id
 * @param  int investor_id
 * @param  int bank_id
 * @return Investor bank_data
 */
banksService.getBankData = function (investorId, bankId) {
  return apiService.get(`/investor/${investorId}/bank/${bankId}`).then(res => res.data)
}

/**
 * Edit a investors bank_data by it's id
 * @param  int investor_id
 * @param  int bank_id
 * @param  object body
 * @return investor bank_data
 */
banksService.putBankData = function (investorId, bankId, body) {
  return apiService.put(`/investor/${investorId}/bank/${bankId}`, body).then(res => res.data)
}

export default banksService



// WEBPACK FOOTER //
// ./src/services/banks.js